import CustomerList from 'customers/CustomerList'
import CustomerBasicData from 'customers/BasicData'
import NoteList from 'customers/notes/NoteList'
import Parameters from 'customers/Parameters'
import ZoneList from 'customers/ZoneList'
import NumberList from 'customers/NumberList'
import HourList from 'customers/HourList'
import WorkList from 'customers/WorkList'
import TrainingList from 'customers/TrainingList'
import CustomerInvoiceList from 'customers/InvoiceList'
import AttachmentList from 'customers/AttachmentList'
import ContactList from 'customers/contacts/ContactList'
import LocationList from 'customers/locations/LocationList'
//import LocationTable from 'customers/locations/LocationTable'
//import LocationForm from 'customers/locations/LocationForm'
import Location from 'customers/locations/Location'
import ReportList from 'customers/reports/ReportList'
import TimeSheetList from 'customers/TimeSheetList'
import ContactDetails from 'customers/contacts/ContactDetails'
import InvoiceDetail from 'invoices/containers/InvoiceDetail'
import CustomerManualList from 'customers/manuals/ManualList'
import CustomerNewManual from 'customers/manuals/NewTemplateForm'
import NewReport from 'customers/reports/NewReport'
import ReportDetails from 'customers/reports/ReportDetails'
import ReportPrint from 'customers/reports/ReportPrint'
import EmployeeList from 'customers/EmployeeList'
import CustomerTemplateList from 'customers/templates/TemplateList'
import CustomerNewTemplate from 'customers/templates/NewTemplateForm'
import NewTraining from 'customers/NewTraining';
import { BaseUrl } from '../BaseUrl/BaseUrl'

export const RouteConfig = [
  {
    path: '/customer',
    component: CustomerList,

  },
  {
    path: '/customer/:id',
    component: CustomerBasicData,


  },
  {
    path: '/customer/:id/locations',
    component: LocationList,
  },  
  {
    path: '/customer/:id/contacts',
    component: ContactList,

  },
  {
    path: '/customer/:customer_id/contact/new',
    component: ContactDetails,
  },
  {
    path: '/customer/:customer_id/location/new',
    component: Location,
  },
  {
    path: '/contact/:contact_id',
    component: ContactDetails,
  },
  {
    path: '/location/:location_id',
    component: Location,
  },
  {
    path: '/customer/:id/notes',
    component: NoteList,

  },
  {
    path: '/customer/:id/parameters',
    component: Parameters,

  },
  {
    path: '/customer/:id/zones',
    component: ZoneList,

  },
  {
    path: '/customer/:id/employees',
    component: EmployeeList,

  },
  {
    path: '/customer/:id/numbers',
    component: NumberList,

  },
  {
    path: '/customer/:id/hours',
    component: HourList,

  },
  {
    path: '/customer/:id/time_sheets',
    component: TimeSheetList,

  },
  {
    path: '/customer/:id/manuals',
    component: CustomerManualList,

  },
  {
    path: '/customer/:id/manuals/new',
    component: CustomerNewManual,

  },
  {
    path: '/customer/:id/manuals/:manual_id',
    component: CustomerNewManual,

  },
  {
    path: '/customer/:id/templates',
    component: CustomerTemplateList,

  },
  {
    path: '/customer/:id/templates/new',
    component: CustomerNewTemplate,

  },
  {
    path: '/customer/:id/work',
    component: WorkList,

  },
  {
    path: '/customer/:id/training',
    component: TrainingList,

  },
  {
    path: '/customer/:id/training/new',
    component: NewTraining,

  },
  {
    path: '/customer/:id/invoices',
    component: CustomerInvoiceList,

  },
  {
    path: '/customer/:customer_id/invoices/new',
    component: InvoiceDetail,

  },
  {
    path: '/customer/:id/uploads',
    component: AttachmentList,

  },
  {
    path: '/customer/:id/reports',
    component: ReportList,

  },
  {
    path: '/customer/:id/reports/new',
    component: NewReport,

  },
  {
    path: '/customer/:id/reports/:report_id',
    component: ReportDetails,

  },
  {
    path: '/customer/:id/reports/:report_id/print',
    component: ReportPrint,

  }
]
